<template>
    <div>
        <div class="row justify-content-center">
            <div class="container">
                <form v-on:submit.prevent="searchClient()">
                <div class="row justify-content-center mb-3">
                    <dic class="col-sm-6">
                <input type="text" v-model="message.phone"  class="form-control" placeholder="Enter phone no as 0712XXX128" required>
                </dic>
                <dic class="col-sm-2">
                    <button type="submit" class="btn btn-success" ><i class="mdi mdi-magnify"></i></button>
                </dic>
                </div>
                </form>
            </div>
            <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <h5 class="mb-3">Full Name: <i class="text-success">{{ message.name }}</i></h5>
                            <h4 class="mb-3">Phone No: <i class="text-warning">{{ message.phone_found }}</i></h4>
                            <h4 class="mb-2">CP Power: <i class="text-primary">Ksh.{{ formatPrice(message.credit+message.safaicom_credit+message.airtel_credit) }}</i></h4>
                            <h4>Status: <i v-if="message.status=='0'" class="text-success">Active</i><i v-else class="text-danger">Blacklisted</i></h4>
                          </div>
                        </div>
                      </div>
            <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Airtime Converted</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/mpesa.png" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh: {{formatPrice(message.credit)}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Safaricom Airtime</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/saf.jpeg" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(message.safaicom_credit)}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Other Airtime</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/airtel2.png" style="width: 10%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(message.airtel_credit)}}</h3>
                          </div>
                        </div>
                      </div>
        </div>

        <div class="row">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item" role="presentation">
    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Airtime Conversion</button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" id="bonga-tab" data-bs-toggle="tab" data-bs-target="#bonga" type="button" role="tab" aria-controls="bonga" aria-selected="false">Bonga <i class="text-danger">Ksh.{{ formatPrice(message.bonga) }}</i></button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Airtime Purchased</button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" id="wallet-tab" data-bs-toggle="tab" data-bs-target="#wallet" type="button" role="tab" aria-controls="wallet" aria-selected="false">Wallet TopUp</button>
  </li>

</ul>
<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
    <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead >
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">System Ref</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Credit Value</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Mpesa</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                        <th class=" text-uppercase  text-xxs font-weight-bolder ">Type</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                        {{data.system_ref}}
                      </td>
                      <td >
                       {{formatPrice(data.value)}}
                      </td>
                      <td >
                      Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>
                      <td  v-if="data.status==='PENDING'">
                       <i class="text-warning">PENDING</i>
                      </td>
                      <td  v-else-if="data.status==='FAILED'">
                       <i class="text-danger">TRANS FAILED</i>
                      </td>
                      <td  v-else>
                       <i class="text-success">DISBURSED</i>
                      </td>
                      <td v-if="data.type=='airtime'" class="text-success">
                       SAFARICOM AIRTIME
                      </td>
                      <td v-else class="text-danger">
                        AIRTEL AIRTIME
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="converted"  @changePage="onChangePage" ></jw-pagination>
                    </div>
                </div>
    </div>
    <div class="tab-pane fade" id="bonga" role="tabpanel" aria-labelledby="bonga-tab">
    <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead >
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">System Ref</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Bonga Value</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Mpesa</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                        <th class=" text-uppercase  text-xxs font-weight-bolder ">Type</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in bongas" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                        {{data.system_ref}}
                      </td>
                      <td >
                       {{formatPrice(data.value)}}
                      </td>
                      <td >
                      Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>
                      <td  v-if="data.status==='PENDING'">
                       <i class="text-warning">PENDING</i>
                      </td>
                      <td  v-else-if="data.status==='FAILED'">
                       <i class="text-danger">TRANS FAILED</i>
                      </td>
                      <td  v-else>
                       <i class="text-success">DISBURSED</i>
                      </td>
                      <td  class="text-success">
                       BONGA
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>

    </div>

  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">.
    <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Account</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Amount Paid</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Credit Issued</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Method</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Telco</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Ip Addrress</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in pageOfItems2" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                      <td >
                        {{data.account}}
                      </td>
                      <td >
                      Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{formatPrice(data.credit)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>
                      <td  v-if="data.disbursed==='N'">
                       <i class="text-danger">PENDING</i>
                      </td>
                      <td  v-else>
                       <i class="text-success">DISBURSED</i>
                      </td>
                      <td >
                        {{data.TransactionType}}
                      </td>
                      <td v-if="data.telco==='SAFARICOM'" class="text-success">
                        {{data.telco}}
                      </td>
                      <td v-else class="text-danger">
                        {{data.telco}}
                      </td>
                      <td >
                        {{data.ip_address}}
                      </td>

                    </tr>

                  </tbody>
                </table>

              </div>
               <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="airtimes"  @changePage="onChangePage2" ></jw-pagination>
                    </div>
                </div>
  </div>
  <div class="tab-pane fade" id="wallet" role="tabpanel" aria-labelledby="wallet-tab">
    <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Account</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Amount</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Method</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Telco</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Ip Addrress</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in wallet_logs" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                      <td >
                        {{data.account}}
                      </td>
                      <td >
                      Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>

                      <td >
                        {{data.TransactionType}}
                      </td>
                      <td v-if="data.telco==='SAFARICOM'" class="text-success">
                        {{data.telco}}
                      </td>
                      <td v-else class="text-danger">
                        {{data.telco}}
                      </td>
                      <td >
                        {{data.ip_address}}
                      </td>

                    </tr>

                  </tbody>
                </table>

              </div>
        </div>
</div>

        </div>

    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
                message:{credit:'0',airtel_credit:'0',safaicom_credit:'0',phone_found:'XXXXXXXXXX',phone:'',name:'',bonga:'0'},
                converted:[],
                airtimes:[],
                wallet_logs:[],
                pageOfItems:[],
                pageOfItems2:[],
                bongas:[],

            }
        },
        created(){

        },
        methods: {
            onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
        onChangePage2(pageOfItems2) {
            this.pageOfItems2 = pageOfItems2;
        },
            searchClient(){
                this.$loading(true)
                let uri =`/api/auth/searchClient`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                    if(response.data.state){
                    this.message.credit=response.data.credit;
                    this.message.airtel_credit=response.data.airtel_credit;
                    this.message.safaicom_credit=response.data.safaicom_credit;
                    this.message.phone=response.data.phone_found;
                    this.message.name=response.data.name;
                    this.message.phone_found=response.data.phone_found;
                    this.message.status=response.data.status;
                    this.converted=response.data.converted;
                    this.airtimes=response.data.airtimes;
                    this.wallet_logs=response.data.wallet_logs;
                    this.message.bonga=response.data.bonga;
                    this.bongas=response.data.bongas;
                    }
                }).catch(error => {
                    this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },


            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }
        },
    }

</script>
